/**
 * 排出事業者招待
 */
import Vue from 'vue'
import * as httpConst from '../../../constants/httpConst'
import * as types from '../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/emissions`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0,
    },
    condition: {
      limit: 50,
      code: null,
      company_name: null,
      subscriber_no: null,
    },
  }
}

const emission = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    index ({ dispatch, commit, state }, { code, company_name, subscriber_no, page, limit }) {
      dispatch('saveCondition', { 
        code: code,
        company_name: company_name,
        subscriber_no: subscriber_no,
        limit: limit
        
      })
      const params = { 
        code: state.condition.code, 
        company_name: state.condition.company_name,
        subscriber_no: state.condition.subscriber_no,
        only_dxe: true,
        limit: state.condition.limit,
        page: page 
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          commit(types.DRIVER_EMISSION_MANAGEMENT, { content })
          resolve(data.content)
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })

    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
    saveCondition ({ commit, state }, { code, company_name, subscriber_no, limit}) {
      const _code = (code !== undefined) ? code : state.condition.code
      const _company_name = (company_name !== undefined) ? company_name : state.condition.company_name
      const _subscriber_no = (subscriber_no !== undefined) ? subscriber_no : state.condition.subscriber_no
      const _limit = (limit !== undefined) ? limit : state.condition.limit
      const params = { 
        code: _code,
        company_name: _company_name, 
        subscriber_no: _subscriber_no,
        limit: _limit,
      }
      commit(types.DRIVER_EMISSION_MANAGEMENT_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.DRIVER_EMISSION_MANAGEMENT_RESET_CONDITION)
    },
  },
  mutations: {
    [types.DRIVER_EMISSION_MANAGEMENT_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_EMISSION_MANAGEMENT] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_EMISSION_MANAGEMENT_CONDITION] (state, { params }) {
      state.condition.code = params.code,
      state.condition.company_name = params.company_name,
      state.condition.subscriber_no = params.subscriber_no
      state.condition.limit = params.limit
    },
  },
}

export default emission

